import React, { useEffect } from "react";

import { useTracking } from "react-tracking";

const NavbarIconsUserRole = () => {
  
  const { trackEvent } = useTracking();

  useEffect(() => {
    
    trackEvent({ component: "ListUserRole", event: "ListUsers-Clicked" });
  }, []);

  return <div className="d-flex justify-content-end gradient-custom-sky custom-nav-height"></div>;
};

export default NavbarIconsUserRole;
